module.exports = __webpack_public_path__ + "static/UIButtons@2x-1b3464c2e597c06d5c309a3f9624dadf.jpg";